<template>
  <header>
    <top-status-bar></top-status-bar>
    <!-- 页面切换tab -->
    <div class="bottom-wrap">
      <div class="content">
        <router-link class="tab" to="/">
          <div class="logo hand"></div>
        </router-link>
        <slot>
          <div class="tab-wrap">
            <router-link class="tab" v-for="(item, index) in tabContent" :key="index"
              :class="{ choose: activeTabsIndex === index }" :to="item.path">
              <div class="font">{{ item.name }}</div>
              <div class="border"></div>
            </router-link>
          </div>
          <div class="search-wrap">
            <div class="search-icon"></div>
            <input type="text" placeholder="输入关键字" />
          </div>
        </slot>
      </div>
    </div>
  </header>
</template>

<script>
import TopStatusBar from '@/components/TopTab/TopStatusBar'
export default {
  name: 'TopTab',
  components: { TopStatusBar },
  data() {
    return {
      tabContent: [
        {
          name: '首页',
          path: '/'
        },
        {
          name: '大咖',
          path: '/author'
        },
        {
          name: '锦囊',
          path: '/jinNang'
        },
        {
          name: '点金',
          path: '/dianjin'
        },
        {
          name: '课程',
          path: '/course'
        },
        {
          name: '我的',
          path: '/mine'
        }
      ]
    }
  },
  computed: {
    activeTabsIndex() {
      const path = this.$route.path

      return this.tabContent.findIndex(item =>
        item.path === '/' ? item.path === path : ~path.indexOf(item.path)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/style/variable/index.scss';

header {
  width: 100%;
  position: fixed;
  z-index: 1001;
  top: 0;
}

.bottom-wrap {
  height: 70px;
  background-color: #046bcc;
  box-shadow: 0px 5px 10px 0px rgba(4, 107, 204, 0.4);

  .logo {
    width: 142px;
    height: 42px;
    background: url('./images/logo.png') no-repeat;
    background-size: cover;
  }

  .tab-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #ffffff;
    font-size: 16px;
    margin-left: 42px;
    flex: 1;

    .tab {
      margin-right: 45px;
      cursor: pointer;
      color: #ffffff;
      text-decoration: none;

      &.choose {
        position: relative;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -10px;
          width: 32px;
          height: 3px;
          background-color: #ffffff;
        }
      }
    }
  }

  .search-wrap {
    flex: 0 0 200px;
    height: 30px;
    background-color: #1e7ad1;
    border-radius: 15px;
    display: none;
    align-items: center;

    .search-icon {
      width: 16px;
      height: 16px;
      background: url('./images/search.png') no-repeat;
      background-size: cover;
      margin: 0 10px 0 50px;
      flex: none;
    }

    input {
      display: block;
      background: transparent;
      border: none;
      outline: none;
      flex: 1;
      color: #ffffff;
      font-size: 14px;

      &::placeholder {
        color: #ffffff;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
}

.content {
  width: $page-width;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

a,
.hand {
  cursor: pointer;
}
</style>
